// eslint-disable-next-line no-restricted-imports
// eslint-disable-next-line no-restricted-imports
import type { DialogProps as MuiDialogProps } from '@mui/material';
import { Dialog as MuiDialog } from '@mui/material';

import { Z_INDEX } from '@/config/z-index';
import { normalizeSx } from '@/shared/lib/normalizeSx';
import type { Sx } from '@/shared/types/uiTypes';

export type BaseDialogProps = MuiDialogProps;

const defaultSx: Sx = {
  zIndex: Z_INDEX.dialog,
  '& .MuiPaper-root.MuiDialog-paper': { backgroundColor: 'gx.mainBackground' },
  '& .MuiBackdrop-root': { backgroundColor: 'rgba(18, 22, 63, 0.80)' }
};

export const BaseDialog = ({ sx, children, ...rest }: BaseDialogProps) => (
  <MuiDialog
    sx={[defaultSx, ...normalizeSx(sx)]}
    {...rest}
  >
    {children}
  </MuiDialog>
);
